import { useEffect } from 'react';
import { NotificationManager } from 'react-notifications';
import { consumePersistedNotification } from 'utils/persistedNotification';

const showNotification = ({ type, message, title, timeOut, callback, priority }) => {
    const safeTimeOut = typeof timeOut === 'number' ? timeOut : 5000;

    switch (type) {
        case 'success':
            return NotificationManager.success(message, title, safeTimeOut, callback, priority);
        case 'warning':
            return NotificationManager.warning(message, title, safeTimeOut, callback, priority);
        case 'error':
            return NotificationManager.error(message, title, safeTimeOut, callback, priority);
        case 'info':
        default:
            return NotificationManager.info(message, title, safeTimeOut, callback, priority);
    }
};

const PersistedNotificationGate = () => {
    useEffect(() => {
        const pending = consumePersistedNotification();
        if (!pending) return;
        if (!pending.message) return;
        showNotification(pending);
    }, []);

    return null;
};

export default PersistedNotificationGate;

